import { render, staticRenderFns } from "./BaseJinNangPanel.vue?vue&type=template&id=0f609875&scoped=true&"
import script from "./BaseJinNangPanel.vue?vue&type=script&lang=js&"
export * from "./BaseJinNangPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseJinNangPanel.vue?vue&type=style&index=0&id=0f609875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f609875",
  null
  
)

export default component.exports